var React = require('react');

function BackArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.76857 11.6765L0.146076 6.77375C-0.048692 6.56737 -0.048692 6.23395 0.146076 6.02703L4.76857 1.12433C5.04973 0.825746 5.50719 0.825746 5.78885 1.12433C6.07002 1.4229 6.07002 1.90749 5.78885 2.20607L1.83456 6.40066L5.78885 10.5942C6.07002 10.8933 6.07002 11.3779 5.78885 11.6765C5.50719 11.975 5.04973 11.975 4.76857 11.6765Z","fill":"#40196D"}));
}

BackArrowInline.defaultProps = {"width":"6","height":"12","viewBox":"0 0 6 12","fill":"none"};

module.exports = BackArrowInline;

BackArrowInline.default = BackArrowInline;
